<!--
Author: TangChen
Date: 2018-09-12
Desc: 获取图形验证码弹框，为公共组件
 -->
<template>
    <div class="comp-mobile-code comp">
        <el-dialog title="" :visible.sync="visible" width="405px" class="prop" v-on:close="dialogClose">
            <el-form ref="form" :model="form" :rules="ruleVerify" v-on:submit.native.prevent>
                <el-form-item label="">
                    <p class="prop-text">
                        为了您的账户安全，请输入手机验证码：
                    </p>
                </el-form-item>
                <el-form-item label="" required>
                    <el-col :span="24">
                        <el-form-item label="" prop="verify">
                            <el-input v-model.trim="form.verify" class="img-code-val" placeholder="请输入手机验证码" :maxlength="6" />
                        </el-form-item>
                    </el-col>
                </el-form-item>
            </el-form>
            <el-form slot="footer" class="dialog-footer">
                <el-button type="primary" v-on:click="submitForm('form')">
                    确 定
                </el-button>
                <el-button v-on:click="dialogClose">
                    取 消
                </el-button>
            </el-form>
        </el-dialog>
    </div>
</template>
<script>
export default {
    name: "ImgCode",
    props: {
        mobileVisible: {
            type: Boolean,
            required: true
        }
    },
    data () {
        return {
            form: {
                verify: ""
            },
            visible: false, // 是否显示dialog
            ruleVerify: {// 验证码校验
                verify: [
                    { validator: this.$util.validateVerifyCode, trigger: "blur" }
                ]
            }
        };
    },
    watch: {
        mobileVisible (val) {
            this.visible = val;
            if (!val) {
                this.$refs["form"].resetFields();
            }
        }
    },
    /* 初始化加载数据 */
    mounted () {
    },
    methods: {
        /* 提交表单数据 */
        submitForm (formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.$emit("verify-in", this.form.verify);
                } else {
                    // todo
                    return false;
                }
            });
        },
        dialogClose () {
            this.$emit("verify-in");
        }
    }
};
</script>
<style lang="scss">
    .comp-mobile-code {
        img-code-val{height: 40px;}
    }
</style>
